import {
  DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_BEGIN,
  DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_SUCCESS,
  DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_FAILURE,
  DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
export function updateSupabaseExternalDb(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_BEGIN,
    });
    const {
      projectId,
      version,
      externalDbUuid,
      result,
      tableIndex,
      collectionTitle,
      selectedPrimaryKey,
    } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/supabase/${externalDbUuid}`,
        { fields: result, tableIndex: tableIndex, collectionTitle, selectedPrimaryKey },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateSupabaseExternalDbError() {
  return {
    type: DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_BEGIN:
      return {
        ...state,
        updateSupabaseExternalDbPending: true,
        updateSupabaseExternalDbError: null,
      };

    case DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_SUCCESS:
      return {
        ...state,
        updateSupabaseExternalDbPending: false,
        updateSupabaseExternalDbError: null,
      };

    case DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_FAILURE:
      return {
        ...state,
        updateSupabaseExternalDbPending: false,
        updateSupabaseExternalDbError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_DISMISS_ERROR:
      return {
        ...state,
        updateSupabaseExternalDbError: null,
      };

    default:
      return state;
  }
}
